module.exports = __webpack_public_path__ + "img/2.3a1c3170.jpg";